module.exports = __webpack_public_path__ + "static/media/red-pdf.98601b44.svg";